import React from "react";
const GENERIC_MESSAGE = "chat.error.generic";
const TURN_FAILED_MESSAGE = "chat.error.turnFailed";
const MESSAGE_BY_CODE = {
    "load-failed": "chat.error.loadFailed",
    "stop-failed": "chat.error.stopFailed",
    "tool-approval-failed": "chat.error.toolApprovalFailed",
    "client-tool-failed": "chat.error.clientToolFailed"
};
export const isUsageLimitMessage = (raw)=>raw.includes('"usage-limit-reached"');
export const canUpgradeFromMessage = (raw)=>!/"canUpgrade"\s*:\s*false/.test(raw);
const UNAUTHORIZED_CODE = /\bE_(UNAUTHORIZED_ACCESS|OFFICE_TOKEN_INVALID)\b/;
function humanizeTransportError(raw) {
    const status = raw.match(/\b(4\d\d|5\d\d)\b/)?.[1];
    if (status === "401" || status === "403" || UNAUTHORIZED_CODE.test(raw)) {
        return "chat.error.sessionExpired";
    }
    if (status && status.startsWith("5")) {
        return "chat.error.unavailable";
    }
    if (/failed to fetch|networkerror|load failed|econnrefused|aborted/i.test(raw)) {
        return "chat.error.offline";
    }
    return GENERIC_MESSAGE;
}
function describeTurnError(stored) {
    const message = humanizeTransportError(stored ?? "");
    return message === GENERIC_MESSAGE ? TURN_FAILED_MESSAGE : message;
}
export function describeChatError(requestError, sdkError, status, lastMessage) {
    const error = requestError ? {
        ...requestError,
        message: MESSAGE_BY_CODE[requestError.message] ?? GENERIC_MESSAGE
    } : sdkError && status === "error" && !isUsageLimitMessage(sdkError.message ?? "") ? {
        id: `transport-error-${Date.now()}`,
        source: "transport",
        message: humanizeTransportError(sdkError.message ?? ""),
        retryable: true,
        timestamp: Date.now()
    } : null;
    if (lastMessage?.role !== "assistant" || lastMessage.metadata?.status !== "error") {
        return error;
    }
    return {
        ...error ?? {
            id: `turn-error-${lastMessage.id}`,
            source: "workflow",
            message: describeTurnError(lastMessage.metadata.error),
            timestamp: Date.now()
        },
        retryable: false
    };
}
export function useChatError(httpError, sdkError, status, lastMessage) {
    const failedTurn = lastMessage?.metadata?.status === "error" ? lastMessage : undefined;
    return React.useMemo(()=>describeChatError(httpError, sdkError, status, failedTurn), [
        httpError,
        sdkError,
        status,
        failedTurn
    ]);
}
